/**
 * Request cancel-token container for HTTP clients.
 * Replaces caribe7/services/main/request/tokens.js.
 *
 * Use with shared/api/http-client: pass RequestClient to renewCancelToken;
 * use the returned value (or its .token) as config.cancelToken.
 */

import RequestClient from 'shared/api/http-client';

type CancelSource = ReturnType<typeof RequestClient.createCancelToken>;

const requestSource = {
  cancel_tokens: {} as Record<string, CancelSource>,

  createCancelToken(request_client: typeof RequestClient, token_key: string): CancelSource {
    const source = request_client.createCancelToken();
    this.cancel_tokens[token_key] = source;
    return source;
  },

  getCancelToken(token_key: string): CancelSource | null {
    return this.cancel_tokens[token_key] ?? null;
  },

  cancelToken(token_key: string): void {
    const source = this.getCancelToken(token_key);
    if (source) source.cancel();
  },

  renewCancelToken(request_client: typeof RequestClient, token_key: string): CancelSource {
    if (this.getCancelToken(token_key) !== null) {
      this.cancelToken(token_key);
      delete this.cancel_tokens[token_key];
    }
    return this.createCancelToken(request_client, token_key);
  },
};

export default requestSource;
